"use client";

import { useEffect, useState } from "react";
import es from "./es.json";
import en from "./en.json";

export default es;

export function useContent() {
  const [content, setContent] = useState(es);

  useEffect(() => {
    setContent(window.location.pathname.startsWith("/en") ? en : es);
  }, []);

  return content;
}
